import { z } from "zod";

const applyFormSchema = z.object({
  basicInfo: z.object({
    name: z.string().min(1, "필수 입력 사항 입니다."),
    email: z
      .string()
      .min(1, "필수 입력 사항 입니다.")
      .email("이메일 형식으로 입력해주세요."),
    phone: z
      .string()
      .min(1, "필수 입력 사항 입니다.")
      .max(13, "필수 입력 사항 입니다.")
      .regex(
        /^[0-9]{3}-[0-9]{4}-[0-9]{4}$/,
        "010-1234-5678 형식으로 입력해주세요."
      ),
    applyPath: z.string().nonempty("필수 입력 사항 입니다."),
    // birthDate: z
    //   .date({
    //     invalid_type_error: "필수 입력 사항 입니다.",
    //     required_error: "필수 입력 사항 입니다.",
    //   })
    //   .min(new Date("1900-01-01"), "필수 입력 사항 입니다."),
    experience: z.object({
      isNew: z.boolean(),
      years: z
        .number()
        .optional()
        .refine((val) => {
          if (!val) return true; // 신입인 경우
          return parseInt(val) > 0; // 경력자인 경우
        }, "필수 입력 사항 입니다."),
    }),
  }),
  resume: z.object({
    resume: z
      .instanceof(FileList, { message: "필수 입력 사항입니다." })
      .refine((files) => files.length > 0, {
        message: "필수 입력 사항입니다.",
      })
      .refine((files) => files[0]?.type === "application/pdf", {
        message: "PDF 파일만 업로드 가능합니다.",
      })
      .refine((files) => files[0]?.size <= 20 * 1024 * 1024, {
        message: "파일 크기는 20MB 이하만 가능합니다.",
      }),
    portfolio: z.union([
      z.null(),
      z.undefined(),
      z
        .instanceof(FileList)
        .refine(
          (files) => files.length === 0 || files[0].type === "application/pdf",
          {
            message: "PDF 파일만 업로드 가능합니다.",
          }
        )
        .refine(
          (files) => files.length === 0 || files[0]?.size <= 20 * 1024 * 1024,
          {
            message: "파일 크기는 20MB 이하만 가능합니다.",
          }
        ),
    ]),
  }),
  terms: z.object({
    personalInfo: z.boolean().refine((val) => val === true, {
      message: "필수 입력 사항 입니다.",
    }),
    optionalInfo: z.boolean().optional(),
    sensitiveInfo: z.boolean().refine((val) => val === true, {
      message: "필수 입력 사항 입니다.",
    }),
  }),
});

export const useApplyForm = () => {
  const defaultValues = {
    basicInfo: {
      name: "",
      email: "",
      phone: "",
      applyPath: "",
      // birthDate: "",
      experience: {
        isNew: true,
        years: "",
      },
    },
    resume: {
      resume: null,
      portfolio: new DataTransfer().files,
    },
    terms: {
      personalInfo: false,
      optionalInfo: false,
      sensitiveInfo: false,
    },
  };

  return {
    schema: applyFormSchema,
    defaultValues,
    formOptions: {
      mode: "onChange",
      criteriaMode: "all",
      shouldUnregister: false,
      shouldUseNativeValidation: false,
    },
  };
};
